import { Injectable } from '@angular/core';
import { GetBoardingCertificateRequest } from 'src/sdk-servicing';
import { ErrorType, LoginStatusType } from '@lib/interfaces';
import { AswContextStoreService, CommonLibService } from '@lib/services';
import {
  BoardingCertificateSearchCondition,
  BoardingCertificateSearchInitParameter,
  PREVIOUS_PAGE_IDENTIFIER,
} from '@common/interfaces';
import { ServicingBaseClass } from '@common/components';
import { BoardingCertificateCommonStoreService, BoardingCertificateService, ServicingCommonStoreService } from '..';
import { ErrorCodeConstants } from '@conf/app.constants';

@Injectable()
export class BoardingCertificateSearchService extends ServicingBaseClass {
  /** 搭乗証明書PDF取得APIレスポンス異常メッセージコード */
  private static readonly ApiErrorBoardingCertificate: { [errorCode: string]: string } = {
    [ErrorCodeConstants.ERROR_CODES.EBAZ000700]: 'E1280',
    [ErrorCodeConstants.ERROR_CODES.EBAZ000702]: 'E1281',
    [ErrorCodeConstants.ERROR_CODES.EBAZ000777]: 'E1788',
  };

  /**
   * ログインステータスを取得する
   */
  get loginStatus(): LoginStatusType {
    return this._aswContextStoreService.aswContextData.loginStatus;
  }

  constructor(
    private _commonLibService: CommonLibService,
    private _aswContextStoreService: AswContextStoreService,
    private _servicingCommonStoreService: ServicingCommonStoreService,
    private _boardingCertificateCommonStoreService: BoardingCertificateCommonStoreService,
    private _boardingCertificateService: BoardingCertificateService
  ) {
    super();

    this.watchGetBoardingCertificateFailure();
  }

  override destroy(): void {}

  /**
   * 搭乗証明書検索初期化パラメータを取得する
   */
  getInitParameter(): BoardingCertificateSearchInitParameter {
    const localDate = this._boardingCertificateService.pointOfSaleLocalDate;

    const yearAgo1 = this._boardingCertificateService.getYearAdded(localDate, -1);
    const fromDepartureDate = this._boardingCertificateService.getYearMonthDay(yearAgo1);

    const yearAgo2 = this._boardingCertificateService.getYearAdded(localDate, -2);
    const fromPurchaseDate = this._boardingCertificateService.getYearMonthDay(yearAgo2);

    const toDate = this._boardingCertificateService.getYearMonthDay(localDate);

    let lastSearchCondition: BoardingCertificateSearchCondition | undefined;
    if (
      this._servicingCommonStoreService.servicingCommon.previousPageIdentifier ===
      PREVIOUS_PAGE_IDENTIFIER.BOARDING_CERTIFICATE_SELECT
    ) {
      lastSearchCondition = this._boardingCertificateCommonStoreService.model?.lastSearchCondition;

      this._boardingCertificateCommonStoreService.clear('lastSearchCondition');
    }

    return {
      lastSearchCondition,
      fromDepartureDate,
      fromPurchaseDate,
      toDate,
    };
  }

  /**
   * 検索ボタン押下処理
   * @param condition 搭乗証明書検索条件
   */
  search(condition: BoardingCertificateSearchCondition): void {
    this._servicingCommonStoreService.updateServicingCommon({
      boardingCertificateSearchCondition: condition,
    });
  }

  /**
   * 搭乗証明書表示ボタン押下処理
   * @param condition 搭乗証明書表示条件
   */
  issue(condition: GetBoardingCertificateRequest): void {
    this._boardingCertificateService.requestBoardingCertificate(condition);
  }

  /**
   * 搭乗証明書PDF取得APIレスポンス異常取得
   */
  private watchGetBoardingCertificateFailure(): void {
    this.subscribeService(this._boardingCertificateService.getBoardingCertificateFailure$, (state) => {
      const apiErrorCode = state?.errors?.[0]?.code;

      if (apiErrorCode && apiErrorCode in BoardingCertificateSearchService.ApiErrorBoardingCertificate) {
        this._commonLibService.errorsHandlerService.setNotRetryableError({
          errorType: ErrorType.BUSINESS_LOGIC,
          errorMsgId: BoardingCertificateSearchService.ApiErrorBoardingCertificate[apiErrorCode],
          apiErrorCode: apiErrorCode,
        });
      } else {
        this._commonLibService.errorsHandlerService.setNotRetryableError({
          errorType: ErrorType.SYSTEM,
          apiErrorCode: apiErrorCode,
        });
      }
    });
  }
}
